<template>
    <Page withNavbar withNavigation>
        <main>
            <TypeformWidget
                v-if="config.TYPEFORM_ID"
                :id="config.TYPEFORM_ID"
                @submit="onSubmit"
            />
            <h3 v-else>
                Typeform is not configured !
            </h3>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer, CastingConsumer, TrackingConsumer } from '@skeepers/platform-framework/mixins';
import { Page } from '@skeepers/platform-framework/components/mobile';

import { ApplicationConsumer } from '@/mixins';
import { TypeformWidget } from '@/components/shared';

export default {
    name: 'Typeform',
    components: { Page, TypeformWidget },
    mixins: [SolutionConsumer, CastingConsumer, ApplicationConsumer, TrackingConsumer],
    props: {
        next: {
            type: String,
            default: 'deposit',
        },
    },
    methods: {
        async onSubmit () {
            this.trackEvent('CASTING_TYPEFORM_END');
            await this.updateProgress('TYPEFORM');
            this.$router.push({ name: this.next });
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/mixins';
@import '~@skeepers/platform-framework/assets/scss/colors';

main {
    @include flex-vertical();
    flex-grow: 1;
}
</style>
